module.exports = __webpack_public_path__ + "assets/img/google_play.c0b5ed8c.png";